var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogContainer",
    {
      attrs: {
        showDialog: _vm.showDialog,
        title: "Add Model",
        icon: "add",
        toolbarActions: [
          {
            text: "Save",
            icon: "save",
            buttonColor: "success",
            emitEvent: "onSubmitClicked",
            showIsLoading: true,
            isDisabledFunc: () => !_vm.isFormValid,
          },
          {
            text: "Cancel",
            depressed: true,
            emitEvent: "onCancelClicked",
          },
        ],
        isLoading: _vm.isLoading,
      },
      on: {
        onCancelClicked: _vm.onCancelClicked,
        onSubmitClicked: _vm.onSubmitClicked,
      },
    },
    [
      _c(
        "v-container",
        { attrs: { "pa-0": "", "grid-list-lg": "" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.isFormValid,
                callback: function ($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid",
              },
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlTextField", {
                        attrs: {
                          label: "Model Name*",
                          autofocus: "",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledManufacturerList,
                          autocomplete: "",
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                          label: "Model Manufacturer*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.manufacturerId,
                          callback: function ($$v) {
                            _vm.manufacturerId = $$v
                          },
                          expression: "manufacturerId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledCategoryList,
                          autocomplete: "",
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                          label: "Model Category*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.categoryId,
                          callback: function ($$v) {
                            _vm.categoryId = $$v
                          },
                          expression: "categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("small", [_vm._v("*indicates required field")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }